import { useCallback, useContext, useEffect, useRef } from 'react';
import { modalsControllerContext } from './context';
export function useModalsController() {
    const context = useContext(modalsControllerContext);
    if (!context) {
        throw new Error('useModalController must be used inside ModalContextProvider');
    }
    return context;
}
export function useOpenModal(ModalComponent, hookProps, deps) {
    const modalsController = useModalsController();
    const openedModalRef = useRef(undefined);
    const callbackPropsRef = useRef(undefined);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => { var _a; return (_a = openedModalRef.current) === null || _a === void 0 ? void 0 : _a.closeModal(); };
    }, []);
    useEffect(() => {
        var _a;
        (_a = openedModalRef.current) === null || _a === void 0 ? void 0 : _a.updateProps({
            ...hookProps,
            ...(callbackPropsRef.current || {})
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return useCallback(async (callbackProps) => {
        callbackPropsRef.current = callbackProps;
        const modal = modalsController.openModal(ModalComponent, {
            ...hookProps,
            ...(callbackProps || {})
        });
        openedModalRef.current = modal;
        const modalResult = await modal.promise;
        openedModalRef.current = undefined;
        modal.closeModal();
        return modalResult;
    }, [ModalComponent, hookProps, modalsController]);
}
